import React, { useCallback, useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/logo.png';
import "../../styles/MyProfile.css";
import { faBriefcaseClock } from '@fortawesome/free-solid-svg-icons';
import QRCode from 'react-qr-code';


const MyQR = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState.user._id;
  const userCode = authState.user.think5whyscode;

  const [profileData, setProfileData] = useState({
    userId: authState.user._id,
    name: authState.user.name,
    gender: 0,
    dob: '',
    email: authState.user.email,
    mobile: '',
    city: '',
    institution: '',
    socialLinks: '',
    personalPageLink: '',
    think5whysCode: authState.user.think5whyscode,
    image: '',
  });

  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [urlToScan, setUrlToScan]=useState('');

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    const config = {
      url: "/myprofile/byid",
      method: 'post',
      data: { userId: userId },
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setProfileExists(true);
          const { profile } = response;
          setProfileId(profile._id);
          setProfileData({
            userId: profile.userId,
            name: profile.name,
            gender: profile.gender,
            dob: profile.dob,
            email: profile.email,
            mobile: profile.mobile,
            city: profile.city,
            institution: profile.institution,
            socialLinks: profile.socialLinks,
            personalPageLink: profile.personalPageLink,
            think5whysCode: profile.think5whysCode,
          });
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        }
      })
      .catch(error => {
        console.error("Error getting profile:", error);
        setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
      });
  }, [userId, fetchData, authState.token]);

  const origin = window.location.origin;
  const qrValue = `${origin}/pub/${profileData.think5whysCode}`;
  
  // console.log(qrValue);

  return (
      <div className="flex flex-col justify-center items-center p-4 relative">
        <div className="bg-gradient-to-r from-gray-200 to-gray-400 border border-gray-600 rounded-lg shadow-lg w-full max-w-sm p-4">
          <h2 className="text-gray-800 font-bold text-2xl mb-2 text-center">{profileData.name}</h2>
          <p className="text-sm text-gray-600 mb-1 text-center">ID#: {profileData.think5whysCode}</p>
          <div className="bg-black border-4 border-gray-600 rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
            <QRCode value={qrValue} size={128} className="bg-white p-2 rounded-md shadow-md" />
            <a href={qrValue} target="_blank" rel="noopener noreferrer" className='text-xs flex flex-wrap items-center'>
              {qrValue}
            </a>
          </div>
          <div className="rounded-lg mt-2 p-4 w-full max-w-sm flex flex-col justify-center items-center">
            <p className="text-red-700 text-center text-sm py-2 rounded-md mt-2">
                Powered by <img src={logo} alt="Think5Whys" className="inline-block w-6 h-6 mx-2"/> think5whys.com
            </p>
          </div>
      </div>
    </div>
   );
};

export default MyQR;
